import type { BodyRequest } from '@pba/utils';
import type { Time } from 'models';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { ActivityContentObjectDetailDataObject } from 'models/service';

type ActivityBody = {
  description?: string;
  end_time?: string;
  html_description?: string;
  is_dexcom?: boolean;
  is_withings?: boolean;
  multiple_submissions?: boolean;
  name?: string;
  periodicity_type?: string;
  programs_topic?: ProgramsTopic;
  programs_topic_id: string;
  reminders?: RemindersItem[];
  start_time?: string;
  tasks?: TasksItem[];
  times?: Time[];
};

type ProgramsTopic = {
  id: string;
};

type RemindersItem = {
  minutes: number;
};

type TasksItem = {
  input?: string;
  kind?: string;
  name?: string;
};

export const updateActivity = async ({
  body,
  routeParams: { id },
}: { routeParams: { id: string } } & BodyRequest<ActivityBody>) =>
  apiClient.put<ActivityContentObjectDetailDataObject, ApiClientResponse<ActivityContentObjectDetailDataObject>>(
    routes.activities.update(id),
    { activity: body },
  );
